import { EVENT_STATUS_V2 } from '../../../types/event';

export const EVENT_STATUS_LABEL_V2 = {
  [EVENT_STATUS_V2.INACTIVE]: '비활성',
  [EVENT_STATUS_V2.ACTIVE]: '활성',
  [EVENT_STATUS_V2.UNLIMITED]: '무기한',
};

export const EVENT_STATUS_SELECT_LIST_V2 = Object.values(EVENT_STATUS_V2).map((status) => ({
  id: status,
  name: EVENT_STATUS_LABEL_V2[status],
}));
